import { ChallengeFailure } from '../challenge-failure';

export type RedeemChallengeRequest = {
	challengeId: string,
	solution: string
}

export type RedeemChallengeResult = void | ChallengeFailure;

export type RedeemChallengeAction = (
	request: RedeemChallengeRequest
) => Promise<RedeemChallengeResult>;
